import { useMoodHistory } from '@/hooks/useMoodHistory';
import { useLanguage } from '@/i18n/LanguageContext';

const moodEmoji: Record<string, string> = {
  reflective: '🪞',
  anxious: '😰',
  calm: '🌊',
  curious: '🔍',
  melancholic: '🌧️',
  restless: '⚡',
  grateful: '🙏',
  numb: '🫥',
  hopeful: '🌅',
  overwhelmed: '🌀',
};

const MoodHistory = () => {
  const { history } = useMoodHistory();
  const { t } = useLanguage();

  if (history.length < 2) return null;

  return (
    <div className="space-y-2">
      <h3 className="text-[10px] uppercase tracking-widest text-muted-foreground/30 flex items-center gap-2">
        <span className="w-1 h-1 rounded-full bg-muted-foreground/20" />
        {t('mood_history') || 'Mood History'}
      </h3>
      <div className="flex items-center gap-1.5 overflow-x-auto pb-1 scrollbar-hide">
        {history.slice(-14).map((entry, i) => (
          <div
            key={i}
            className="flex flex-col items-center gap-0.5 min-w-[28px]"
            title={`${entry.mood} — ${new Date(entry.timestamp).toLocaleDateString()}`}
          >
            <span className="text-sm">{moodEmoji[entry.mood] || '•'}</span>
            <span className="text-[8px] text-muted-foreground/20">
              {new Date(entry.timestamp).getDate()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MoodHistory;
